<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="detail_content">
          <div class="prospectus_title">
            {{inforList.student_name}} —— {{inforList.assess_name}}
          </div>
          <div class="score" v-if="inforList.check_score != 0 && inforList.check_score">
            <span>分数：</span><span class="nopass">{{inforList.check_score}}</span>
          </div>
          <ul class="prospectus_ul final">
            <li v-for="(item,index) in detailList" :key="index">
              <div class="question">{{item.subject_name}}</div>
              <div class="answer ">
                <div class="checkbox" v-if="item.type === 2">
                  <el-checkbox  disabled 
                    v-for="items in item.option_list"
                    :key="items.option_id"
                    :label="items.option_id"
                    :checked="items.checked"
                    :value="items.option_id">{{items.option_name}}</el-checkbox>
                </div>
                <div class="radio" v-else-if="item.type === 1">
                  <el-radio v-model="item.answer_id" disabled 
                    v-for="items in item.option_list"
                    :key="items.option_id"
                    :label="items.option_id"
                    :value="items.option_id">{{items.option_name}}</el-radio>
                </div>
                <p v-else>答：{{item.answer_result}}</p>  
              </div>
            </li>
          </ul>
          <div class="audit" v-if="inforList.status!=0">
            <p>
              <span class="audit_title">审核状态：</span>
              <span class="audit_content nopass" v-if="inforList.status===0">未审核</span>
              <span class="audit_content nopass" v-else-if="inforList.status===5">审核失败</span> 
              <span class="audit_content pass" v-else-if="inforList.status===10">审核合格</span> 
            </p>
            <p><span class="audit_title">审核老师：</span><span class="audit_content">{{inforList.teacher}}</span><span class="audit_title">审核时间：</span><span class="audit_content">{{inforList.time}}</span></p>
            <p v-if="inforList.status === 5 "><span class="audit_title">不通过原因：</span><span class="audit_content">{{inforList.reson}}</span></p>
            <p v-if="inforList.status === 10"><span class="audit_title">审核评语：</span><span class="audit_content">{{inforList.comment}}</span></p>
          </div>
          <!-- <div class="audit_btn" > -->
          <div class="audit_btn" v-if="inforList.status != 10 ">
            <el-button type="success"  @click="audit(inforList.status)">审核</el-button>
          </div>
        </div>
      </div>
    </div>
    <Modal :title="title" :type="type" :final="final" v-if="showdialog" :showdialog="showdialog" @dialogConfirm="dialogConfirm" @dialogConcel="dialogConcel"></Modal>
  </div>
</template>
<script>
import Modal from '../../components/ideaModal';
  export default{
    name:'finalEvaluationDetail',
    components:{
      Modal

    },
    data(){
      return {
        detailList:{},
        inforList:{},
        type:0,
        title:'期末评估表——审核',
        showdialog:false,
        final:'final'
      }
    },
    created(){
      this.id = this.$route.params && this.$route.params.id
      let params = {
        id:this.id,
      }
      this.getinfor(params)
    },
    mounted(){
      
    },
    methods:{
      getinfor(params){
        this.$api.user.assessDetail(params)
          .then(res=>{
            if(res.code === 0){
              this.inforList = res.result
              let arr = this.inforList.result
              for(let i = 0;i < arr.length;i++){
                if(arr[i].type === 2){
                  for(let j = 0 ; j < arr[i].option_list.length ;j++){
                    arr[i].option_list[j].checked = false
                    if(arr[i].option_list[j].is_checked === 1){
                      arr[i].option_list[j].checked = true
                      break
                    }
                  }
                }
                if(arr[i].type === 1){
                  for(let j = 0 ; j < arr[i].option_list.length ;j++){
                    arr[i].answer_id = ''
                    if(arr[i].option_list[j].is_checked === 1){
                      arr[i].answer_id = arr[i].option_list[j].option_id
                      break
                    }
                  }
                }
              }
              this.detailList = arr
            }
          }) 
      },
      dialogConfirm(data){
        let params = {
          id:this.inforList.id,
          status:Number(data.status),
          reson:data.check_reson,
          // score:data.check_score,
          comment:data.check_comment,
        }
        this.$api.user.assessCheck(params)
        .then(res=>{
          if(res.code === 0){
            this.showdialog = false
            this.$message.success('审核成功')
            let params = {
              id:this.id,
            }
            this.getinfor(params)
          }
        }) 
      },
      dialogConcel(){
        this.showdialog = false
      },
      audit(status){
        this.showdialog = true
        this.type = status
      }
    },
    watch:{
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/prospectusDetail.scss';
  // @import '../../assets/scss/finalEvaluationDetail.scss';
</style>